"use client";

import { useCardStore } from "@/util/store/card";
import { PersianNum } from "@/util/tools/PersianNum";
import { ShoppingBag } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

const BasketHeader = () => {
  const router = useRouter();
  const { cart } = useCardStore();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <Link href="/order/check" aria-label="order" className="relative">
      <span>
        <ShoppingBag aria-hidden="true" className="text-text1 size-6" />
        {cart.length > 0 && (
          <span className="absolute top-[-4px] right-0 flex items-center justify-center h-5 w-5 border text-xs font-bold leading-none bg-pink transform translate-x-1/2 -translate-y-1/2 text-white rounded-full">
            {PersianNum(cart.length)}
          </span>
        )}
      </span>
    </Link>

  )
};

export default BasketHeader;
